import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import Textarea from '@/components/forms/Textarea';
import { Translation, useDynamicLocale } from '@/hoslog-intl';
import { useFormContext } from 'react-hook-form';
import { BUSINESS_TYPES } from '../businessType';
import { businessTypeOptions } from '../premiumStores.constant';

export type ClubInfoFormValues = {
  storeName: string;
  storeNameFurigana: string;
  groupName: string;
  description: string;

  businessType: string;
  ceoFullName: string;
  ceoFurigana: string;
  companyName: string;
  companyNameFurigana: string;
  companyAddress: string;
  landlineNumber: string;
  mobileNumber: string;
  emailAddress: string;
  username: string;
};

export const BusinessInfo = ({
  selectedBusinessType = '',
  businessTypeFromApi = '',
  premiumStoreId,
}: {
  selectedBusinessType?: string;
  businessTypeFromApi?: string;
  premiumStoreId?: string;
}) => {
  const { register } = useFormContext<ClubInfoFormValues>();
  const { t } = useDynamicLocale();
  const isDisabled = !!premiumStoreId;

  return (
    <div className="w-full space-y-6">
      <div className="flex gap-5 sm:gap-10 md:gap-15 lg:gap-20">
        <div className="text-lg font-semibold min-w-[150.4px] w-[200px] xl:w-[302px] pl-12"></div>
        <div className="w-full ">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              forceRequired
              label="storeManagement.form.storeInfo.label.storeName"
              placeholder={t('storeManagement.storeInfo.storeNamePlaceholder')}
              {...register('storeName')}
              maxLength={50}
            />
            <Input
              forceRequired
              label="storeManagement.form.storeInfo.label.furigana"
              placeholder={t('storeManagement.storeInfo.furiganaPlaceholder')}
              maxLength={50}
              {...register('storeNameFurigana')}
            />
            <Input
              label="storeManagement.form.storeInfo.label.groupName"
              {...register('groupName')}
              maxLength={50}
              placeholder={t('storeManagement.storeInfo.groupNamePlaceholder')}
            />
          </div>
          <div className="mt-4">
            <Textarea
              label="storeManagement.form.storeInfo.label.description"
              placeholder={t('common.form.placeholder.description')}
              className="resize-none"
              isRequired
              maxLength={200}
              {...register('description')}
            />
          </div>
        </div>
      </div>

      <div className="flex gap-5 sm:gap-10 md:gap-15 lg:gap-20">
        <div className="w-[200px] xl:w-[302px] pl-12">
          <p className="text-base font-semibold  whitespace-nowrap">
            <Translation id="storeManagement.premiumStores.manageStoreInformation.fieldTitle.businessInfo" />
          </p>
        </div>

        <div className="w-full">
          <div className="w-[200px] xl:w-[302px] mb-4.5">
            <Select
              forceRequired
              selected={businessTypeFromApi}
              options={businessTypeOptions}
              placeholder={t('common.form.placeholder.select')}
              label="storeManagement.form.businessInfo.label.businessType"
              name="businessType"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="storeManagement.form.businessInfo.label.ceoName"
              placeholder={t('common.form.placeholder.ceoFullName')}
              forceRequired
              {...register('ceoFullName')}
              maxLength={50}
            />
            <Input
              label="storeManagement.form.businessInfo.label.furigana"
              placeholder={t('common.form.placeholder.furiganaPlaceholder')}
              forceRequired
              {...register('ceoFurigana')}
              maxLength={50}
            />
            {selectedBusinessType === BUSINESS_TYPES.CORPORATION && (
              <>
                <Input
                  label="common.form.label.companyName"
                  placeholder={t('common.form.placeholder.companyName')}
                  forceRequired
                  {...register('companyName')}
                  maxLength={50}
                />
                <Input
                  label="storeManagement.form.businessInfo.label.furigana"
                  placeholder={t('common.form.placeholder.companyFurigana')}
                  forceRequired
                  {...register('companyNameFurigana')}
                  maxLength={50}
                />
              </>
            )}
            <Input
              label="storeManagement.form.businessInfo.label.companyAddress"
              placeholder={t('common.form.placeholder.companyAddress')}
              {...register('companyAddress')}
              maxLength={50}
            />
            <Input
              label="storeManagement.form.businessInfo.label.landlineNumber"
              placeholder={t('common.form.placeholder.landlineNumber')}
              {...register('landlineNumber')}
              maxLength={11}
              inputMode="numeric"
              type="text"
              onlyNumbers
              forceRequired
            />
            <Input
              label="storeManagement.form.businessInfo.label.mobileNumber"
              placeholder={t('common.form.placeholder.mobileNumber')}
              forceRequired
              disabled={isDisabled}
              {...register('mobileNumber')}
              inputMode="numeric"
              type="text"
              onlyNumbers
              maxLength={11}
            />
            <Input
              label="storeManagement.form.businessInfo.label.emailAddress"
              placeholder={t('common.form.placeholder.emailAddress')}
              forceRequired
              disabled={isDisabled}
              {...register('emailAddress')}
              maxLength={50}
            />
            <Input
              label="storeManagement.form.businessInfo.label.username"
              disabled
              {...register('username')}
              maxLength={50}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
